<section id="secao-titulo-educacao-tecnologica">
  <div class="container">
    <div class="titulo-educacao-tecnologica">
      <h2>Iniciação Tecnológica</h2>
    </div>
  </div>
</section>
